import React from 'react';
import Image from 'next/image'
import {css} from "@emotion/react";
import topBackground from '~/images/shop/top/top_background.jpg'
import Copy from '../../../../../public/images/shop/top/copy.svg'
import styled from "@emotion/styled";
import {useSelector} from "react-redux";
import itemImage from '~/images/shop/top/item_image.png'
import SubText from '../../../../../public/images/shop/top/sub_text.svg'
import colorPalette from "../../../../styles/theme/colorPalette";
import {isMobileOnly} from "react-device-detect";

const MainVisual = () => {
  const signIn = useSelector((state) => state.login.login)
  
  return (
      <>
        <div css={background}>
          <NavMargin signin={signIn}/>
          <div css={[main,isMobileOnly ? mobileStyle : '']}>
            <Copy/>
          </div>
        </div>
        <div css={featureWrapper}>
          <div css={itemImageWrapper}>
            <Image src={itemImage}/>
          </div>
          <SubText css={subText}/>
        </div>
      </>
  );
};

export default MainVisual;

const background = css`
  background-image: url(${topBackground.src});
  background-size: cover;
  background-position: top center;
  width: 100%;
  min-height: 400px;
  max-height: 570px;
  height: 50vw;
  position: relative;
`

const main = css`
  margin: auto;
  max-width: 780px;
  width: 100%;
  padding: 30px 0 0;
`

const mobileStyle = css`
  padding: 0 !important;
`

const itemImageWrapper = css`
  position: absolute;
  left: 0;
  right: 0;
  top: -192px;
  max-width: 600px;
  margin: auto;
  padding: 20px;
`

let NavMargin = styled.div({
},props => ({
  height: props.signin ? '100px' : '142px'
}))

const featureWrapper = css`
  position: relative;
  max-height: 234px;
  min-height: 70px;
  height: 32vw;
  margin: 0 auto;
  text-align: center;
  background-color: #feb868;
  // background: ${colorPalette.primaryGradient.gradient};
`

const subText = css`
  max-width: 430px;
  width: 90%;
  bottom: 0px;
  left: 0;
  right: 0;
  margin: auto;
  //z-index: 100;
  position: absolute;
  //background-color: rgba(255,255,255,0.8);
  //border-radius: 8px;
`